import { authDaoFactory } from '../common'
import { errorUtil } from '../util/error-util'

const dao = authDaoFactory({
  onError: async (error: Error) => {
    errorUtil.handleHttpError(error)
  },
})

export const authDao = {
  ...dao,
  deactivateOwnAccount: async (): Promise<void> => {
    await dao._http.post(`/users/me/deactivate`)
  },
}
